import apiClient from './apiClient';

// GET Home full data
export async function getHomeFullData(params) {
  const response = await apiClient.get('/home/fulldata', { params });
  return response.data.data;
}

// Subscribe API
export async function subscribeToNewsLetter(data) {
  const response = await apiClient.post('/home/subscribe_newsletter', data);
  return response.data.data;
}

// Contact form API
export async function contactFormSend(data) {
  const response = await apiClient.post('/home/submit_fom', data);
  return response.data.data;
}

export default {
  getHomeFullData,
  subscribeToNewsLetter,
  contactFormSend,
};
